import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('admin_token') || '',
    admin: JSON.parse(localStorage.getItem('admin_info') || 'null')
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('admin_token', token)
    },
    SET_ADMIN(state, admin) {
      state.admin = admin
      if (admin) {
        localStorage.setItem('admin_info', JSON.stringify(admin))
      } else {
        localStorage.removeItem('admin_info')
      }
    }
  },
  actions: {
    login({ commit }, { token, admin_id, username, name, role }) {
      commit('SET_TOKEN', token)
      commit('SET_ADMIN', { admin_id, username, name, role })
    },
    logout({ commit }) {
      commit('SET_TOKEN', '')
      commit('SET_ADMIN', null)
    }
  }
})
